import { SAVE_PROVIDER } from 'state/provider/constants'

export function saveProvider(payload) {
  return {
    type: SAVE_PROVIDER,
    payload,
  }
}
